module.exports = __webpack_public_path__ + "img/Main.02fae2d.png";